import { Button } from '@/hen-ui/atomics/Button';

import type { CareerExplorerPeekExpandToggle as CareerExplorerPeekExpandToggleLabels } from './types';

interface CareerExplorerPeekExpandToggleProps {
  controlsId: string;
  expanded: boolean;
  labels: CareerExplorerPeekExpandToggleLabels;
  onToggle: () => void;
}

export const CareerExplorerPeekExpandToggle = ({
  controlsId,
  expanded,
  labels,
  onToggle,
}: CareerExplorerPeekExpandToggleProps) => (
  <Button
    type='button'
    variant='primaryOutline'
    size='flush'
    aria-controls={controlsId}
    aria-expanded={expanded}
    onClick={onToggle}
    className='mt-2xl w-full border-secondary-700 px-sm py-xs text-l1 font-semibold leading-l1 text-secondary-700'
  >
    {expanded ? labels.expandedLabel : labels.collapsedLabel}
  </Button>
);
